module.exports = __webpack_public_path__ + "static/logo-02-9505461591081525e82aec5e65517a7e.svg";